import { ConfigAnimationStyle } from '../config-provider/AnimationContext';
export function getMaskStyle(animation) {
    let maskStyle = {};
    if (typeof animation?.glassmorphism === 'object') {
        maskStyle = animation?.glassmorphism;
    }
    else if (typeof animation?.glassmorphism === 'boolean') {
        maskStyle = animation?.glassmorphism ? ConfigAnimationStyle.glassmorphism.modal : {};
    }
    return maskStyle;
}
